<div class="lg-container color-container">
  <label class="lg-label">{{label}}</label>
  <div class="input-container">
    <input [formControl]="control" matInput class="input form-control">
    <i class="material-icons circle" [ngStyle]="{'color':control.value}">
      lens
    </i>
  </div>
</div>
